export default "__VITE_ASSET__C4M9H4V9__"